import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import api from "@/lib/api";
import { RESOURCE_ICONS, downloadUrl, downloadLabel } from "@/lib/resources";

export default function Libros() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    document.title = "Libros y Recursos — Modo Pro";
    api.get("/recursos").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <main data-testid="libros-page" className="bg-mp-black min-h-screen pt-32 md:pt-40">
      <section className="mx-auto max-w-[1440px] px-6 lg:px-12 pb-16">
        <div className="mp-eyebrow mb-6">Biblioteca Modo Pro</div>
        <h1 data-testid="libros-title" className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-[-0.02em] max-w-3xl uppercase">
          Libros y <span className="text-mp-orange">Recursos</span>
        </h1>
        <p data-testid="libros-subtitle" className="mt-6 font-display text-white text-xl md:text-2xl max-w-2xl">
          “El conocimiento no termina cuando acaba el episodio.”
        </p>
        <p className="mt-4 text-white/70 max-w-2xl">
          Descubre libros, herramientas, plantillas y recursos compartidos por nuestros invitados para ayudarte a llevar tus conocimientos al siguiente nivel.
        </p>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 lg:px-12 pb-24">
        {items && items.length === 0 && (
          <div data-testid="libros-empty" className="border border-white/10 p-16 text-center bg-mp-off">
            <div className="mp-eyebrow">Próximamente</div>
            <p className="mt-4 font-display text-white text-2xl">Nuevos recursos muy pronto.</p>
          </div>
        )}
        {items && items.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((r) => <ResourceCard key={r.id} r={r} />)}
          </div>
        )}
      </section>
    </main>
  );
}

function ResourceCard({ r }) {
  const Icon = RESOURCE_ICONS[r.resource_type] || RESOURCE_ICONS["Material complementario"];
  return (
    <article id={r.id} data-testid={`resource-card-${r.id}`} className="group border border-white/10 bg-mp-off p-8 flex flex-col hover:border-mp-orange/50 transition-colors duration-500">
      <div className="flex items-start justify-between gap-4">
        <div className="h-14 w-14 flex items-center justify-center border border-mp-orange/40 text-mp-orange">
          <Icon size={26} strokeWidth={1.5} />
        </div>
        <span data-testid={`resource-free-${r.id}`} className="bg-mp-orange/15 text-mp-orange font-display text-[10px] tracking-[0.24em] uppercase px-3 py-1">
          Descarga gratuita
        </span>
      </div>
      <div className="mt-8 text-xs tracking-[0.24em] uppercase text-mp-orange font-display">{r.resource_type}</div>
      <h3 className="mt-2 font-display text-white text-xl md:text-2xl leading-tight tracking-[-0.01em]">{r.title}</h3>
      {r.guest_name && <p className="mt-1 text-mp-mute text-sm">Con {r.guest_name}</p>}
      {r.description && <p className="mt-4 text-white/70 text-sm leading-relaxed">{r.description}</p>}
      <div className="mt-auto pt-8">
        <a href={downloadUrl(r.id)} download={r.file_name} data-testid={`resource-download-${r.id}`} className="mp-btn-primary w-full justify-center">
          <Download size={14} /> {downloadLabel(r)}
        </a>
      </div>
    </article>
  );
}
